<template>
  <div :class="[containerDefaultClass, containerClass, {inactive: disabled}]">
    <button :class="buttonClass" :disabled="disabled" @click="handleClick">
      <slot name="default"></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  emits: ['button:click'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    containerDefaultClass: {
      type: [String, Object, Array],
      default: 'outline_fancy_btn'
    },
    containerClass: {
      type: [String, Object, Array],
      default: ''
    },
    buttonClass: {
      type: String,
      default: 'fancy_btn'
    }
  },
  methods: {
    handleClick (event) {
      if (this.disabled) { return }

      this.$emit('button:click', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/button/BaseButton.vue